module.exports = __webpack_public_path__ + "static/media/1017001BE.a1c84c7d.jpg";